import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import List from "./List";
import PopUp from "./PopUp";

function TableSelector({ order }) {
	const { rooms, tables, shop, setTableSelectorVisible, updateOrder, editCart2 } =
		useContext(AppContext);
	const [room, setRoom] = useState(false);
	const [filteredRooms, setFilteredRooms] = useState([]);
	const [filteredTables, setFilteredTables] = useState([]);
	const [srcParam, setSrcParam] = useState("");
	const currentOrderId = order?.order_id || order?.id || null;
	const hasCurrentTable = Boolean(order?.table_id);

	useEffect(() => {
		if (rooms) {
			setFilteredRooms(rooms.filter((e) => e.shop_id == shop.id));
		}
	}, [rooms]);

	useEffect(() => {
		if (filteredRooms.length > 0) {
			setRoom(filteredRooms[0]);
		}
	}, [filteredRooms]);

	useEffect(() => {
		if (room) {
			let filtered = tables;
			if (srcParam) {
				filtered = tables.filter(
					(t) => t.name.toLowerCase().search(srcParam.toLowerCase()) > -1
				);
			}
			setFilteredTables(
				filtered.filter((e) => e.room_id == room.id && e.id != order.table_id)
			);
		}
	}, [room, tables, srcParam]);

	const handleSelection = (el) => {
		console.log(el);
		setTableSelectorVisible(false);
		if (order.table_id) {
			updateOrder(order, {
				room_id: room.id,
				table_id: el.id,
				self_cart_id: el.cart_id || null,
			});
		} else {
			editCart2({
				delivery_type: { id: "shop", name: "Sala" },
				room_id: room.id,
				room: room,
				table: el,
				self_cart_id: el.cart_id || null,
			});
		}
	};

	return (
		<>
			<PopUp
				size="sm"
				customClass=" table-selector"
				options={{
					onClose: () => setTableSelectorVisible(false),
					title: currentOrderId
						? "Ordine " + currentOrderId
						: hasCurrentTable
							? "Cambia tavolo"
							: "Sposta ordine su tavolo",
					subtitle: "Scegli il tavolo di destinazione",
					content: (
						<>
							<div className="horizzontal-menu">
								{filteredRooms.map((r, i) => (
									<button
										key={i}
										onClick={() => setRoom(r)}
										className={r.id == room.id ? "active" : ""}
									>
										{r.name}
									</button>
								))}
							</div>
							<div className="src-group">
								{srcParam && (
									<button
										className="button square"
										onClick={(e) => setSrcParam("")}
									>
										X
									</button>
								)}
								<input
									type="text"
									value={srcParam}
									onChange={(e) => setSrcParam(e.target.value)}
									placeholder="Ricerca"
								/>
							</div>
							<List
								mode={3}
								//className="table-list"
								elements={filteredTables}
								onClick={handleSelection}
							/>
						</>
					),
				}}
			/>
		</>
	);
}

export default TableSelector;
